module.exports = __webpack_public_path__ + "img/main_ani_1.9602bbed.png";